import { render, staticRenderFns } from "./PackageConfigBuilder.vue?vue&type=template&id=093bca46&scoped=true"
import script from "./PackageConfigBuilder.vue?vue&type=script&lang=ts"
export * from "./PackageConfigBuilder.vue?vue&type=script&lang=ts"
import style0 from "./PackageConfigBuilder.vue?vue&type=style&index=0&id=093bca46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093bca46",
  null
  
)

export default component.exports